module.exports = __webpack_public_path__ + "static/img/new12-Wu3Vr8Ke.29319be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new12-Wu3Vr8Ke.png
// module id = sfE5
// module chunks = 16